import { apiSlice as api } from "./rtk-api/apiSlice"

interface IGetFeatureFlagsResponse {
  success: boolean
  flags: Record<string, boolean>
}

const injectedRtkApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getFeatureFlags: builder.query<IGetFeatureFlagsResponse, void>({
      // ComingSoonRoute shows its own retry when this fails (MPE-1367).
      query: () => ({ url: "/v1/feature-flags", method: "GET", suppressErrorToast: true }),
      providesTags: ["FeatureFlags"],
    }),
  }),
})

export const { useGetFeatureFlagsQuery } = injectedRtkApi

export default injectedRtkApi
